import { IsNotEmpty, IsUUID } from 'class-validator';

export class TemplatePreviewDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;
}
